import Fn from "../../Fn"

class SectionFour {
  constructor () {
    this.$slickNav = $('#sectionFour .slickNav')
    this.$slickFor = $('#sectionFour .slickFor')
    
    this.init()
  }
  
  init () {
    // handler slickNav images lists
    this._slickNavImagesListsHandler()
    // handler slick
    this._slickCall()
  }
  
  /**
   * 处理slick
   * @private
   */
  _slickCall () {
    this.$slickNav.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (nextSlide === 3) {
        $('#sectionFour .slick-next').hide()
      } else {
        $('#sectionFour .slick-next').show()
      }
      
      if (nextSlide === 0) {
        $('#sectionFour .slick-prev').hide()
      } else {
        $('#sectionFour .slick-prev').show()
      }
    })
    
    this.$slickNav.on('init', () => $('#sectionFour .slick-prev').hide())
    
    this.$slickNav.slick({
      swipe: true,
      dots: true,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      asNavFor: '#sectionFour .slickFor',
      prevArrow: '<button type="button" class="slick-prev slickArrow"><i class="icon-keyboard-arrow-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slickArrow"><i class="icon-keyboard-arrow-right"></i></button>'
    })
    
    this.$slickFor.slick({
      dots: false,
      arrows: false,
      infinite: false,
      waitForAnimate: false, //  不等待animate执行结束
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      asNavFor: '#sectionFour .slickNav',
    })
  }
  
  /**
   * 处理轮播框内的图片功能
   * @private
   */
  _slickNavImagesListsHandler () {
    this.$slickNav.find('.slickNav--item').map((k, el) => {
      let images = JSON.parse(el.dataset.slickBg)
      let randomString = Fn.randomString()
      
      el.classList.add(randomString)
      Fn.writeStyle(`${randomString}Style`, `@media(min-width: ${window.breakPoints.mobile}px){.${randomString}{background-image: url('${images.mb}?random=${window.randomString}');background-size:cover;}}
                                            @media(min-width: ${window.breakPoints.tablet}px){.${randomString}{background-image: url('${images.tab}?random=${window.randomString}')}}
                                            @media(min-width: ${window.breakPoints.pc}px){.${randomString}{background-image: url('${images.pc}?random=${window.randomString}')}}`);
      
      //  计算slick for item 的高度
      this.slickNavItemSizeCalc()
      $(window).resize(() => this.slickNavItemSizeCalc())
    })
    
    this.$slickFor.find('.slick--item').map((k, el) => $(el).css('background-image', `url("${el.dataset.slickBg}?random=${window.randomString}")`))
  }
  
  /**
   * 计算slick for item 的高度
   */
  slickNavItemSizeCalc () {
    let width = this.$slickNav.outerWidth()
    if (window.innerWidth >= window.breakPoints.pc) {
      this.$slickNav.find('.slickNav--item').height(Math.floor(width * 0.4444))
    } else if (window.innerWidth >= window.breakPoints.tablet) {
      this.$slickNav.find('.slickNav--item').height(Math.floor(width * 0.7009))
    } else {
      this.$slickNav.find('.slickNav--item').height(Math.floor(width * 1.2586))
    }
  }
  
}

export default SectionFour
